import React, { ReactElement } from 'react';

import SheetContainer, { Content, Header, Heading, Overlay, Sheet } from '../../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import LabelDeleteConfirmationContent from '../components/LabelDeleteConfirmationContent';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';

type LabelDeleteSheetProps = {
    onDelete: () => void;
    sheetProps: UseSheetReturnType;
};

const LabelDeleteSheet = ({ onDelete, sheetProps }: LabelDeleteSheetProps): ReactElement => {
    const translate = useTranslator('popup', 'labels.edit');

    return (
        <SheetContainer className="LabelDeleteSheet" {...sheetProps}>
            <Overlay />
            <Sheet>
                <Header>
                    <Heading>{translate('deleteTitle')}</Heading>
                </Header>
                <Content>
                    <div className="p-4">
                        <LabelDeleteConfirmationContent onDelete={onDelete} onCancel={sheetProps.dispatchCloseSheet} />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default LabelDeleteSheet;
